import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import bg from '../../images/bg-parcking.svg'
import Logo from '../../images/logo-black.svg'

const DEEP_LINK_SCHEME = 'respublikapark://'

type CallbackStatus = 'success' | 'failure' | null

const DiiaCallback = () => {
  const [searchParams] = useSearchParams()
  const status = searchParams.get('status') as CallbackStatus

  const [appOpened, setAppOpened] = useState(false)

  const openInApp = () => {
    window.location.href = `${DEEP_LINK_SCHEME}diia-callback?status=${status ?? 'failure'}`
    setAppOpened(true)
  }

  useEffect(() => {
    openInApp()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isSuccess = status === 'success'

  return (
    <div
      className="flex justify-center bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${bg})`, minHeight: '100vh' }}
    >
      <div className="flex flex-col mt-40 max-w-xl min-w-300" style={{ padding: '0 24px' }}>
        <header className="flex items-start justify-start">
          <img src={Logo} alt="logo" className="w-80" />
        </header>

        <div className="flex flex-col items-center justify-center mt-20" style={{ gap: 24 }}>
          <div
            style={{
              width: 96,
              height: 96,
              borderRadius: '50%',
              backgroundColor: isSuccess ? '#2cd5c4' : '#ff5c5c',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 48,
              color: '#fff',
            }}
          >
            {isSuccess ? '✓' : '✕'}
          </div>

          <h2 className="text-3xl text-white font-medium text-center">
            {isSuccess
              ? 'Верифікацію завершено!'
              : 'Верифікацію не вдалося пройти'}
          </h2>

          <p className="text-white text-center" style={{ opacity: 0.8 }}>
            {isSuccess
              ? 'Ваші документи успішно верифіковано. Повертаємось до додатку...'
              : 'Сталася помилка або верифікацію було скасовано. Спробуйте ще раз.'}
          </p>

          <button
            onClick={openInApp}
            style={{
              backgroundColor: '#2cd5c4',
              border: 'none',
              color: '#fff',
              padding: '14px 28px',
              borderRadius: 12,
              cursor: 'pointer',
              width: '100%',
              marginTop: 16,
            }}
          >
            <h3 className="text-xl font-medium text-center">
              Відкрити в додатку Republica Park
            </h3>
          </button>

          {!isSuccess && (
            <p className="text-white text-center" style={{ opacity: 0.6, fontSize: 14 }}>
              Якщо додаток не відкривається — переконайтеся, що він встановлений на вашому пристрої.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default DiiaCallback
